import {
  API_LOGIN,
  API_MFA_RECOVER,
  API_MFA_VERIFY,
} from "../utils/api/ApiConstant";

export const permissionKeys = {
  add: "Add",
  edit: "Edit",
  view: "View",
  delete: "Delete",
};

export const staticURL = {
  "/auth/login": true,
  "/auth/mfa/verify": true,
  "/auth/mfa/recover": true,
};

export const staticUserType = {
  FA: "FA",
  SA: "SA",
  AD: "AD",
  MA: "MA",
  CL: "CL",
};

export const staticRoleType = {
  superadmin: "Superadmin",
};
